import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { LabelValueNumber, ProductPriceTypeEditor, CurrencyItem } from '../../interfaces/interfaces';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'app-productpricetypeeditor',
    templateUrl: './productpricetypeeditor.component.html',
    styleUrls: ['./productpricetypeeditor.component.scss']
})
export class ProductpricetypeeditorComponent extends UnsubscribeComponent implements AfterViewInit {

    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    productPriceTypeId: number = null;
    productPriceTypeEditor: ProductPriceTypeEditor = null;
    dataLoading = false;
    loading = false;
    productPriceTypeEditorFormGroup: FormGroup = null;

    currencies: LabelValueNumber[] = [];

    decimalCounts: LabelValueNumber[] = [
        { label: 'Automatikus', value: -1 },
        { label: '0', value: 0 },    
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 }    
    ];

    init(): void {
        this.initProductPriceTypeEditorFormGroup();
        this.loadData();
    }

    loadData(): void {
        if (this.productPriceTypeId !== null) {
            this.dataLoading = true;
            combineLatest([
                this.apiService.getProductPriceType(this.productPriceTypeId),
                this.apiService.getSimpleTable<CurrencyItem>('currencies')
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(([{productPriceTypeEditor}, {data}]) => {
                this.productPriceTypeEditor = productPriceTypeEditor;
                this.currencies.push(...data.map(d => ({
                    label: d.currency,
                    value: d.id
                })));
                this.fillProductPriceTypeEditorForm(this.productPriceTypeEditor);
            }).add(() => {
                this.dataLoading = false;
            });
        } else {
            this.apiService.getSimpleTable<CurrencyItem>('currencies').subscribe(({data}) => {
                this.currencies.push(...data.map(d => ({
                    label: d.currency,
                    value: d.id
                })));
            });
        }
    }

    initProductPriceTypeEditorFormGroup(): void {
        this.productPriceTypeEditorFormGroup = new FormGroup({
            name: new FormControl('', [Validators.required]),
            isNet: new FormControl(false, [Validators.required]),
            isDefault: new FormControl(false, [Validators.required]),
            decimalCount: new FormControl(-1),
            currencyId: new FormControl(1)
        });
    }

    fillProductPriceTypeEditorForm(productPriceTypeEditor: ProductPriceTypeEditor): void {
        this.productPriceTypeEditorFormGroup.get('name').setValue(productPriceTypeEditor.name);
        this.productPriceTypeEditorFormGroup.get('isNet').setValue(productPriceTypeEditor.isNet);
        this.productPriceTypeEditorFormGroup.get('isDefault').setValue(productPriceTypeEditor.isDefault);
        this.productPriceTypeEditorFormGroup.get('decimalCount').setValue(productPriceTypeEditor.decimalCount);
        this.productPriceTypeEditorFormGroup.get('currencyId').setValue(productPriceTypeEditor.currencyId);
    }

    save(): void {
        if (this.productPriceTypeEditorFormGroup.invalid) {
            return;
        }
        this.loading = true;
        const formValue: any = this.productPriceTypeEditorFormGroup.value;
        if (this.productPriceTypeId === null) {
            this.apiService.createProductPriceType(formValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.updateProductPriceType(this.productPriceTypeId, formValue).pipe(
                takeUntil(this.unsubscribe)
            ).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        }
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }

    constructor(
        private apiService: ApiService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
        this.productPriceTypeId = this.config.data.productPriceTypeId;
        this.init();
    }
}
